import { ContentMap } from './generated.contentMap';
import { CONTENT_TYPE } from './generated.types';

export * from './entry.types';
export * from './generated.types';

export const searchCategories = [
  'realEstate',
  'kotonaArticle',
  'satoPage',
  'release',
] as const;

export type SearchResultCategory = (typeof searchCategories)[number];

export function isContentType<K extends CONTENT_TYPE>(
  obj: any,
  type: K
): obj is ContentMap[K] {
  return obj.contentType === type;
}
